import type { Proposal } from "../../prisma/generated"

export enum ProposalLanguage {
  English = `en`,
  Spanish = `es`,
}

export enum CompensationType {
  PowurLine = `powurline`,
  Holdback = `holdback`,
  DefaultCogs = `default_cogs`,
}

export const MIN_PROPOSAL_MARGIN = 0
export const MAX_PROPOSAL_MARGIN = 4
export const DEFAULT_PROPOSAL_MARGIN = 1.5

export const DEFAULT_PROPOSAL: Proposal = {
  kind: `solar`,
  allowChangeOrderEquipment: false,
  annualEnergyUse: null,
  createdAt: new Date(),
  displayAddressId: ``,
  status: null,
  statusUpdatedBy: null,
  statusUpdatedAt: null,
  summaryConfirmedAt: null,
  downPayment: 0,
  enterpriseId: ``,
  genabilityDefaultContractedRate: null,
  genabilityUsageEstimate: null,
  hourlyConsumptionkWAC: [0],
  id: ``,
  margin: DEFAULT_PROPOSAL_MARGIN,
  mentorId: ``,
  monthlyEnergyCost: Array(12).fill(null),
  monthlyEnergyManualFlags: Array(12).fill(false),
  monthlyEnergyUse: Array(12).fill(null),
  smartEstimateBanner: null,
  smartEstimateBannerSource: null,
  smartEstimateBannerValue: null,
  name: null,
  newCustomerIncentive: false,
  newConstruction: false,
  postSolarUtilityRateId: ``,
  powurProjectId: 0,
  preferredLanguage: ProposalLanguage.English,
  primaryPresenter: 0,
  requiresRefresh: false,
  secondarySystem: false,
  secondaryPresenter: 0,
  sellerId: ``,
  siteId: ``,
  slug: ``,
  systemType: null,
  updatedAt: new Date(),
  usageProfileId: null,
  userAdjustedAfterSolarContractedRate: null,
  userAdjustedBeforeSolarContractedRate: null,
  userAdjustedUtilityRate: null,
  utilityRateEscalationPercentage: 0,
  utilityRateId: ``,
  financeType: `cash`,
  financeProductId: null,
  leadSource: null,
  projectLeadId: null,
  fundingGroup: null,
  documentsOutSentToPlatformAt: null,
  selectedLoanProductId: null,
}
